import script from "./LoaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=c3d3e12c&lang=scss&scoped=true"

import exportComponent from "C:\\AQRepo\\customermanagedinspection_fe-brands-kra-norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3d3e12c"]])

export default __exports__